export const skills = [
  // Frontend
  { text: "HTML & CSS" },
  { text: "JavaScript" },
  { text: "TypeScript" },
  { text: "React.js" },
  { text: "Next.js" },
  { text: "Vite" },
  { text: "Tailwind CSS" },
  { text: "Responsive Design / Mobile" },
  { text: "State Management" },
  { text: "React Hooks" },

  // Backend
  { text: "Node.js" },
  { text: "Express.js" },
  { text: "Nest.js" },
  { text: "Python" },
  { text: "Django" },
  { text: "Django REST Framework (DRF)" },
  { text: "RESTful APIs" },
  { text: "Authentication & Authorization (JWT)" },

  // Database
  { text: "SQL" },
  { text: "PostgreSQL" },
  { text: "Database Design" },
  { text: "DataGrip" },

  // API & Testing
  { text: "Postman" },
  { text: "Axios / Fetch" },
  { text: "API Integration" },

  // DevOps & Deployment
  { text: "Git / GitHub" },
  { text: "Environment Variables" },
  { text: "Netlify / Vercel / Render" },
  { text: "CI/CD" },
  { text: "Docker" },

  // Collaboration & Project Management
  { text: "Jira" },
  { text: "ClickUp" },
  { text: "Miro" },

  // UI / UX & Extras
  { text: "Figma to Code" },
  { text: "Accessibility" },
  { text: "SEO" },
  { text: "Performance Optimization" },
  { text: "AI API Integration" },
];
